import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { planManagementQueries } from '@/services/planManagement/planManagement.queries';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useUpdateAdminPlanMutation = () => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation('updateAdminPlan', {
    onSuccess: async (res) => {
      toast.success(res.message);
      await queryClient.invalidateQueries({ queryKey: [...planManagementQueries.all(), 'list'] });
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });
  return { mutateAsync };
};
